import React, { useContext } from 'react';
import Link from 'next/link';
import { appAuthContext } from 'context/AuthContext';
import useClickStreamEvent from 'utils/clickstream/useClickStreamEvent';
import useFormattedName from 'utils/useFormattedName';
import Chat from '../Chat';
import { HeaderDropdownData as dropdownData } from '../../Header.data';
import styles from './MobileUserCabinet.module.css';

type MobileUserCabinetProps = {
  dropdownOpen: boolean;
  signoutHandler: () => Promise<void>;
  setDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>;
  mobileMenuTogler: () => void;
  showDeclineSignout: boolean;
  setShowDeclineSignout: React.Dispatch<React.SetStateAction<boolean>>;
  showDropdownOpenBtn?: boolean;
  showChat: boolean;
  showCabinetAvatar: boolean;
  profileLinkFromCabinet?: boolean;
};

const MobileUserCabinet = ({
  dropdownOpen,
  signoutHandler,
  setDropdownOpen,
  mobileMenuTogler,
  showDeclineSignout,
  setShowDeclineSignout,
  showDropdownOpenBtn = true,
  showChat,
  showCabinetAvatar,
  profileLinkFromCabinet,
}: MobileUserCabinetProps) => {
  const { user } = useContext(appAuthContext);
  const { sendEvent } = useClickStreamEvent();
  const formattedName = useFormattedName();

  const azUserB2TLabel = user?.azTests?.otvety_topmenu_student_b2t;
  const azUserB2CLabel = user?.azTests?.otvety_topmenu_student_b2c;
  const abTeacherLabel = user?.azTests?.otvety_topmenu_teacher;

  const userTestNewHeaders =
    azUserB2CLabel === 'target_1' ||
    azUserB2CLabel === 'target_2' ||
    azUserB2TLabel === 'target_1' ||
    azUserB2TLabel === 'target_2';

  const teacherTestNewHeaders = abTeacherLabel === 'target';

  const sendClickEvent = async (eventInfo: string) => {
    await sendEvent({
      eventType: 'click',
      eventInfo,
    });
  };

  const dropdownTogler = () => {
    if (dropdownOpen) {
      setShowDeclineSignout(false);
    }
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <div className={styles.cabinet}>
      <div className={styles.cabinet__intro}>
        <div className={styles.profile}>
          {showChat && (
            <div className={styles.chat_wrapper}>
              <Chat />
            </div>
          )}
          {profileLinkFromCabinet ? (
            <a
              href="https://uchi.ru/"
              target="_blank"
              rel="noopener"
              className={styles.cabinet__link}
            >
              {showCabinetAvatar && (
                <div className={styles.avatar_section}>
                  <img
                    src={user?.avatar}
                    className={styles.profile__avatar}
                    alt="avatar"
                  />
                </div>
              )}
              <div className={styles.profile__name}>{formattedName}</div>
            </a>
          ) : (
            <>
              {showCabinetAvatar && (
                <div className={styles.avatar_section}>
                  <img
                    src={user?.avatar}
                    className={styles.profile__avatar}
                    alt="avatar"
                  />
                </div>
              )}
              <div className={styles.profile__name}>{formattedName}</div>
            </>
          )}
        </div>
        {showDropdownOpenBtn && (
          <div
            className={`${styles.profile__dropdown_togler} ${
              dropdownOpen ? styles.dropdown_open : ''
            }`}
            onClick={() => dropdownTogler()}
            data-qa-marker="pers_menu_mob"
          />
        )}
      </div>
      <div
        className={`${styles.cabinet_nav} ${dropdownOpen ? styles.cabinet_nav_show : ''}`}
      >
        <ul className={styles.cabinet_nav__list}>
          {dropdownData.map((item) =>
            (userTestNewHeaders || teacherTestNewHeaders) &&
            item.qaMarker === 'vk_stickers_btn' ? (
              <a
                key={item.src}
                className={styles.cabinet_nav__items}
                href="https://uchi.ru/"
                target="_blank"
                rel="noopener"
                onClick={() => sendClickEvent('otvety_header_uchi_lk')}
              >
                Личный кабинет на&nbsp;Учи.ру
              </a>
            ) : (
              <Link href={item.src} key={item.src}>
                <a
                  onClick={mobileMenuTogler}
                  className={`${styles.cabinet_nav__items}`}
                  data-qa-marker={item.qaMarker}
                >
                  {(userTestNewHeaders || teacherTestNewHeaders) &&
                  item.qaMarker === 'vk_stickers_btn'
                    ? 'Личный кабинет на\u00A0Учи.ру'
                    : item.text.replace('&nbsp;', '\u00A0')}
                </a>
              </Link>
            ),
          )}
        </ul>
        {showDeclineSignout && (
          <div className={styles.signout_alert}>
            При выходе из&nbsp;Учи.Ответов ты&nbsp;также выйдешь из&nbsp;остальных
            сервисов Учи.ру
          </div>
        )}
        <div className={styles.cabinet_nav__signout}>
          <div
            className={styles.cabinet_nav__signout_accept}
            onClick={signoutHandler}
            data-qa-marker="logout_accept_btn_mob"
          >
            Выйти
          </div>
          {showDeclineSignout && (
            <div onClick={() => setShowDeclineSignout(false)}>Остаться</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileUserCabinet;
